// extracted by mini-css-extract-plugin
export var completionBody = "_cj-2";
export var completionCard = "_cj-0";
export var completionFooter = "_cj-3";
export var completionTitle = "_cj-1";